import state from '~store/modules/organizations/state'
import actions from '~store/modules/organizations/actions'

export default {
  state,
  actions
}
